import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {
  button: {
    color: '#452188',
    borderColor: 'rgba(69, 33, 136, 0.5)',
    height: '42px',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 22px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    marginRight: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontSize: '0.9375rem',
    fontWeight: 500,
    textTransform: 'none',
  },
};

const OutlinedButton = ({ icon, text, classes, handleClick }) => {
  return (
    <Button variant="outlined" className={classes.button} onClick={handleClick}>
      {icon && <span className={classes.icon}>{icon}</span>}
      {text && <span className={classes.text}>{text}</span>}
    </Button>
  );
};

OutlinedButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.any,
  handleClick: PropTypes.func,
};

export default withStyles(styles as any, { withTheme: true })(OutlinedButton);
